module.exports = __webpack_public_path__ + "img/WeTube.1d462399.svg";